import { Badge, Text } from '@inmotionnow/momentum-components-react'
import { useTranslation } from 'react-i18next'

import { useFeatureFlag } from '@/features/feature-flags/useFeatureFlag'

/**
 * POC element (KPS-421): rendered only when the `show_experimental_feature`
 * development gate is enabled. Proves the full chain end to end —
 * misc-platform-config → AppConfig → Django → this UI — with no redeploy: the
 * backend reflects a flag toggle within ~30s, and this banner follows on the
 * next fetch of the feature-flags query (page reload / refetch), since the
 * frontend does not poll.
 */
export const ExperimentalFeatureBanner = (): JSX.Element | null => {
  const { t } = useTranslation()
  const { isEnabled } = useFeatureFlag('show_experimental_feature')

  if (!isEnabled) return null

  return (
    <div role='status' data-testid='experimental-feature-banner'>
      <Badge text={t('EXPERIMENTAL_FEATURE_BADGE')} namedColor='tertiary' />
      <Text>{t('EXPERIMENTAL_FEATURE_MESSAGE')}</Text>
    </div>
  )
}
